// frontend/src/components/OrganizationRequests/OrganizationRequests.js
import React from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useDispatch } from "react-redux";
import { getAllOrganizationRequestsAPI } from "../../../redux/features/adminSlice";
import OrganizationRequestsTable from "../../../components/OrganizationsTable/OrganizationRequestsTable";
import AdminNotification from "../../../components/Notification/AdminNotification";

const OrganizationRequests = () => {
  const dispatch = useDispatch();

  const fetchOrganizationRequests = async (token) => {
    return await dispatch(getAllOrganizationRequestsAPI({ token })).unwrap();
  };

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Organization Requests</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>
      <div className="card-default-style px-14 py-40">
        <OrganizationRequestsTable fetchApi={fetchOrganizationRequests} linkTo="/organization-request-details" />
      </div>
    </>
  );
};

export default OrganizationRequests;